// @flow
import React from 'react';
import { connect } from 'react-redux';
import { MdClose } from 'react-icons/lib/md';
import { reduxForm, Field } from 'redux-form';
import { Grid, Row, Col } from 'react-flexbox-grid';
import i18n from 'i18n-js';

import Button from '../../Button/index';
import InlineError from '../../InlineError/index';
import { RenderInput } from '../../FieldRenderer/index';
import styles from './createUserForm.css';
import * as selectors from '../../../reducers/index';
import * as closeableActions from '../../../actions/closeable';
import * as userActions from '../../../actions/users';
import PopupHeader from '../../PopupHeader';
import PopupHeaderLeftGroup from '../../PopupHeaderLeftGroup';
import { onSubmit, validate } from './utils';
import PopupHeaderTitle from '../../PopupHeaderTitle';
import PopupHeaderRightGroup from '../../PopupHeaderRightGroup';
import PopupCloseButton from '../../PopupCloseButton';
import PopupContent from '../../PopupContent';
import PopupFooter from '../../PopupFooter';
import { Cancel } from '../../CommonTexts';

type RouteStopEditFormPropTypes = {
  isEditing: false,
  editError: Function,
  handleSubmit: Function,
};

const ROUTE_STOP_EDIT_FORM_ID = 'editRouteStop';
let RouteStopEditForm = ({
  handleSubmit,
  editError,
  isEditing = false,
}: RouteStopEditFormPropTypes) => (
  <form className={styles.form} id={ROUTE_STOP_EDIT_FORM_ID} onSubmit={handleSubmit}>
    <PopupHeader>
      <PopupHeaderLeftGroup>
        <PopupHeaderTitle title="Editar Parada: " size="medium" />
      </PopupHeaderLeftGroup>
      <PopupHeaderRightGroup>
        <PopupCloseButton
          size="medium"
          Icon={MdClose}
          tint="mediumGray"
          clearMargins
          isTransparent
          isOutlined
        />
      </PopupHeaderRightGroup>
    </PopupHeader>
    <PopupContent>
      <Grid>
        <Row>
          <Col xs={12}>
            <Field
              type="text"
              label={i18n.t('labels.name', { count: 1 })}
              name="name"
              component={RenderInput}
              placeholder="Ej.: Avenida Petapa Z.12"
            />
          </Col>
        </Row>
      </Grid>
      <br />
      <PopupFooter align="center">
        <div className={styles.footer}>
          <Button
            title={Cancel()}
            tint="gray"
            isOutlined
            clearMargins
            type="button"
          />
          <Button
            size="medium"
            title="Guardar Cambios"
            className={styles.approveButton}
            type="submit"
            isLoading={isEditing}
            clearMargins
          />
        </div>
      </PopupFooter>
      <div className={styles.footer}>
        <InlineError objectError={editError} />
      </div>
    </PopupContent>
  </form>
);

RouteStopEditForm = reduxForm({
  form: ROUTE_STOP_EDIT_FORM_ID,
  onSubmit,
  validate,
})(RouteStopEditForm);

RouteStopEditForm = connect(
  (state, props) => {
    const { routeStopId } = props;
    const stop = selectors.getRouteStop(state, routeStopId);
    return {
      initialValues: {
        name: stop.name,
      },
      stop,
      editError: selectors.getRouteStopError(state),
      isCreating: selectors.getRouteStopIsEditing(state),
    };
  },
  dispatch => ({
    close(id) {
      dispatch(closeableActions.close(id));
      dispatch(userActions.addUserCancel());
    },
  }),
)(RouteStopEditForm);

const RouteStopEdit = RouteStopEditForm;

export default RouteStopEdit;



// WEBPACK FOOTER //
// ./src/scripts/components/RouteStopEditPopupContainer/RouteStopEditForm/index.jsx